<template>
  <form @submit.prevent="onSubmit">
    <b-field label="Font Size">
      <b-select v-model="form.font_size" placeholder="Choose font size">
        <option
          v-for="option in fontSizes"
          :key="`font-size-opt-${option.value}`"
          :value="option.value"
          :label="option.label"
        />
      </b-select>
    </b-field>
    <b-field label="Notify When">
      <b-checkbox v-model="form.is_notify_alarm" disabled>Alarm</b-checkbox>
      <b-checkbox v-model="form.is_notify_trouble">Trouble</b-checkbox>
    </b-field>
    <b-field label="Email Notification">
      <b-checkbox v-model="form.is_notify_email"></b-checkbox>
    </b-field>
    <hr />
    <div ref="submit">
      <b-field>
        <b-button
          :loading="isLoading"
          expanded
          native-type="submit"
          type="is-primary"
        >
          Submit
        </b-button>
      </b-field>
    </div>
  </form>
</template>

<script>
import formMixin from '@/mixins/form'
import validationMixin from '@/mixins/validation'
import { required } from '@/utils/validation'

export default {
  mixins: [formMixin, validationMixin],
  data() {
    return {
      isLoading: false,
      fontSizes: [
        { label: 'Large', value: 'large' },
        { label: 'Medium', value: 'medium' },
        { label: 'Small', value: 'small' }
      ],
      rules: {
        font_size: [required],
        landing_page: [required],
        is_notify_alarm: [required],
        is_notify_trouble: [required],
        is_notify_email: [required],
        is_notify_whatsapp: [required]
      },
      form: {
        ...this.$store.state.auth.preferences
      }
    }
  },
  methods: {
    submit() {
      return this.$store.dispatch('auth/setPref', this.form)
        .then(() => {
          this.$buefy.toast.open({
            message: 'Preferences saved',
            type: 'is-success',
            queue: false
          })
        })
    }
  }
}
</script>
